{
  "id": "emerald",
  "name": "Emerald",
  "description": "Minimal neutral base with an emerald accent",
  "colors": {
    "light": {
      "primary": "#0f8f66",
      "secondary": "#d7efe6",
      "positive": "#16a34a",
      "negative": "#dc2626",
      "warning": "#d97706",
      "important": "#ea580c",
      "light": "#f6f6f4",
      "dark": "#0a0a0c",
      "surface": "#ffffff",
      "darksurface": "#15151a",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#34d399",
      "secondary": "#1e2a24",
      "positive": "#4ade80",
      "negative": "#f87171",
      "warning": "#fbbf24",
      "important": "#fb923c",
      "light": "#e7e7ea",
      "dark": "#111114",
      "surface": "#e7e7ea",
      "darksurface": "#15151a",
      "white": "#ffffff"
    }
  }
}
